import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/views/index.vue';
import PageNotFound from '@/views/PageNotFound.vue';

Vue.use(Router);

export default function () {
  const config = {
    linkActiveClass: 'active',
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        component: Main,
      },
      { path: '*', component: PageNotFound },
    ],
  };

  return new Router(config);
}
